import store from '../store';
import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';

async function fetch(data){
    return Request("get","api/examine-material-analyze/",data)
}

async function fetchOne(id,data){
    return Request("get","api/examine-material-analyze/by-district-detail/" + id,data)
}

// 一览导出
async function exports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/examine-material-analyze/export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}
// 明细导出
async function detailExports(id, data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/examine-material-analyze/detail-export/" + id, data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

export default {
    fetch,
    fetchOne,
    exports,
    detailExports,
}